export default __webpack_public_path__ + "static/O0289-42e8a408dfa4daaf77d5d0fff8d585c9.png";